const USER_ID_SECRET_KEY = 'user_id_anonymous_pass_id';

function utf8ToBase64(str: string) {
  return btoa(encodeURIComponent(str));
}

// Function to decode a base64 string back to a UTF-8 string
function base64ToUtf8(base64: string) {
  return decodeURIComponent(atob(base64));
}

export function extendKey(length: number, key: string) {
  const keyLength = key.length;

  return key.repeat(Math.ceil(length / keyLength)).slice(0, length);
}

export function shuffleStringWithKey(str: string, key: string) {
  // Extend the key to match the string length
  const extendedKey = extendKey(str.length, key);
  const strArray = Array.from(str);

  // Create an array of indices based on the extended key
  const indices = strArray.map((_, i) => i);
  indices.sort((a, b) => extendedKey.charCodeAt(a) - extendedKey.charCodeAt(b));

  // Shuffle the string based on sorted indices
  const shuffled = strArray.map((_, i) => str[indices[i] as number]).join('');

  return shuffled;
}

export function unshuffleStringWithKey(shuffledStr: string, key: string) {
  // Extend the key to match the string length
  const strLength = shuffledStr.length;
  const extendedKey = extendKey(strLength, key);

  // Create an array of indices based on the extended key
  const indices = Array.from(shuffledStr).map((_, i) => i);
  indices.sort((a, b) => extendedKey.charCodeAt(a) - extendedKey.charCodeAt(b));

  // Reverse the shuffling by reconstructing the original string
  const unshuffled = new Array(strLength);
  indices.forEach((sortedIndex, i) => {
    unshuffled[sortedIndex] = shuffledStr[i];
  });

  return unshuffled.join('');
}

export const encryptUserId = (userId?: string, secret?: string) => {
  if (!userId) {
    return undefined;
  }

  const encrypted = shuffleStringWithKey(userId.toString(), secret ?? USER_ID_SECRET_KEY);

  // Convert the encrypted string to a base64 URL-safe string
  return utf8ToBase64(encrypted);
};

export const decryptUserId = (encryptedUserId?: string, secret?: string) => {
  if (!encryptedUserId) {
    return undefined;
  }
  // Convert the base64 URL-safe string back to the encrypted string
  const encrypted = base64ToUtf8(encryptedUserId);

  // Ushuffle the ID using the secret key
  return unshuffleStringWithKey(encrypted, secret ?? USER_ID_SECRET_KEY);
};
